module.exports = __webpack_public_path__ + "img/2cf447d.png";